import type { ConversationStatus, MessageRole } from '@conversia/shared-types';

/**
 * "Visto sin responder" (indicador interno del panel): el chat ya fue abierto
 * por alguien del equipo (unreadCount quedó en 0 vía el marcado interno) pero
 * el último mensaje sigue siendo del CLIENTE — nadie contestó (bot apagado o
 * modo humano). PURO y derivado de datos existentes; NO toca WhatsApp ni
 * envía confirmaciones de lectura.
 */
export function vistoSinResponder(c: {
  status: ConversationStatus;
  unreadCount: number;
  /** Último mensaje de la conversación (la lista trae take: 1). */
  messages?: Array<{ role: MessageRole }>;
}): boolean {
  if (c.status === 'CLOSED' || c.status === 'ARCHIVED') return false;
  if (c.unreadCount > 0) return false; // aún sin ver: eso ya lo dice el contador
  const ultimo = c.messages?.[0];
  return ultimo?.role === 'CLIENT';
}
